import { render, staticRenderFns } from "./FacialAccessForm.vue?vue&type=template&id=723b7815"
import script from "./FacialAccessForm.vue?vue&type=script&lang=js"
export * from "./FacialAccessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports